<div class="footer">
  <p>&copy; 2024 Einfach-Behandeln. Ein Service der <a href="https://www.devcon5.ch">DevCon5 GmbH</a></p>
</div>
